module.exports = __webpack_public_path__ + "img/Error.0d1e3e0b.svg";